import { generateUserAgentHeader, urls } from '~/utilities/dataHelpers';
import mediator from '~/utilities/mediator';

type ConnectionsArgs = {
  patientId: string;
  appVersion?: string;
  osType?: string;
  osVersion?: string;
  deviceId: string;
};

export const getCareTeamConnections = async ({
  patientId,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: ConnectionsArgs) => {
  const result = await mediator.request<
    ApiResponse<{ data: CareTeamConnection[] }>
  >('api:invoke', {
    method: 'GET',
    url: `${urls.clmApiUrl}${patientId}/connections/list`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
  });

  if (result.data) {
    return result.data.data;
  }

  throw result;
};

export const addCareTeamConnection = async ({
  patientId,
  clinicId,
  appVersion,
  osType,
  osVersion,
  deviceId,
}: ConnectionsArgs & {
  clinicId: string;
}) => {
  const result = await mediator.request<
    ApiResponse<CareTeamConnectionAddResponse>
  >('api:invoke', {
    method: 'POST',
    url: `${urls.clmApiUrl}${patientId}/connections/add`,
    headers: {
      'X-User-Agent': generateUserAgentHeader({
        appVersion,
        osType,
        osVersion,
      }),
      'X-Device-ID': deviceId,
    },
    data: {
      clinicId,
    },
  });

  if (result.data) {
    return result.data;
  }

  throw result;
};
